import { render, staticRenderFns } from "./AppHeaderDropdown.vue?vue&type=template&id=8a1b5fcc"
import script from "./AppHeaderDropdown.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdown.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderDropdown.vue?vue&type=style&index=0&id=8a1b5fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports